var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgchart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "orgchart",
    clipPath: "url(#clip0_2309_120408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5035 9.63778H13.3124V7.66222H8.50125V6.36444H10.6968C10.9701 6.36444 11.1924 6.14444 11.1924 5.87111V0.493333C11.1924 0.22 10.9701 0 10.6968 0H5.30125C5.02791 0 4.80569 0.22 4.80569 0.493333V5.86889C4.80569 6.14222 5.02791 6.36222 5.30125 6.36222H7.51014V7.66H2.68569V9.63556H0.494579C0.221246 9.63556 -0.000976562 9.85556 -0.000976562 10.1289V15.5044C-0.000976562 15.7778 0.221246 15.9978 0.494579 15.9978H5.89236C6.16569 15.9978 6.38791 15.7778 6.38791 15.5044V10.1289C6.38791 9.85556 6.16569 9.63556 5.89236 9.63556H3.67902V8.64667H12.3212V9.63556H10.1079C9.83458 9.63556 9.61236 9.85556 9.61236 10.1289V15.5044C9.61236 15.7778 9.83458 15.9978 10.1079 15.9978H15.5057C15.779 15.9978 16.0012 15.7778 16.0012 15.5044V10.1289C16.0012 9.85556 15.779 9.63556 15.5057 9.63556L15.5035 9.63778ZM5.7968 0.986667H10.2035V5.37556H5.7968V0.986667ZM5.3968 15.0111H0.990135V10.6222H5.3968V15.0111ZM15.0079 15.0111H10.6012V10.6222H15.0079V15.0111Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2309_120408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgchart);
export default __webpack_public_path__ + "static/media/orgchart.98752f4756f1f83c6e4bd107c9e347c8.svg";
export { ForwardRef as ReactComponent };